import {
  CHANGE_AUTH_FORM,
  SET_AUTH,
  SENDING_AUTH_REQUEST,
  LOGIN_REQUEST,
  REGISTER_REQUEST,
  LOGOUT,
  CLEAR_AUTH_ERROR,
  REGISTER_ACCOUNT_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  VERIFY_CODE_RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST
} from './constants'

export function changeForm(newFormState) {
  return {type: CHANGE_AUTH_FORM, newFormState}
}

export function setAuthState(newAuthState) {
  return {type: SET_AUTH, newAuthState}
}

export function sendingRequest(sending) {
  return {type: SENDING_AUTH_REQUEST, sending}
}

export function loginRequest(data) {
  return {type: LOGIN_REQUEST, data}
}

export function registerRequest(newRegisterState) {
  return {type: REGISTER_ACCOUNT_REQUEST, newRegisterState}
}

export function logout(data) {
  return {type: LOGOUT, data}
}

export function clearError() {
  return {type: CLEAR_AUTH_ERROR}
}

export function forgotPassworddRequest(emailState) {
  return {type: FORGOT_PASSWORD_REQUEST, emailState}
}

export function verifyCodeChangePasswordRequest(verifyCodeState) {
  return {type: VERIFY_CODE_RESET_PASSWORD_REQUEST, verifyCodeState}
}

export function resetPasswordRequest(passwordState) {
  return {type: RESET_PASSWORD_REQUEST, passwordState}
}



// WEBPACK FOOTER //
// ./src/actions/auth.js